const siteTitle = 'Bestellung abschließen';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Remplissez vos informations',
    formTitle2: 'Faire une commande',
    priceText1: 'Zahlung',
    priceText2: 'Gesamt',
    price: '€ 2.95',
    footerTitle: 'Online-Zahlung',
    footerText: 'Mit Ihrer Kreditkarte bestätigen',
  },
  home: {
    placeholder: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'Email',
      phone: 'Telefon',
      city: 'Stadt',
      address: 'Adresse',
      zip: 'Postleitzahl',
      continue: 'Nächste',
      name: 'Der Name',
    },
    cardNumber: 'Kartennummer',
    expirationDate: 'Haltbarkeitsdatum',
    name: 'Name',
    month: 'Monat',
    year: 'Jahr',
    cvv: 'CVV',
    confirmPayment: 'Bezahlen',
    labelNumber: 'Die Kartennummer:',
    labelMonth: 'Ablaufdatum:',
    source:
      'Wir verwenden 3D-Sicherheit, um Ihren Kauf zu verifizieren. Möglicherweise erscheint ein neues Fenster zur Transaktionsüberprüfung ',
    timer: 'Verbleibende Zeit bis zur Bezahlung der Bestellung',
  },
  validation: {
    requireEmail: 'Die E-Mail-Adresse ist vuot',
    validEmail: 'Die E-Mail wurde nicht validiert',
    requirePhone: 'Es ist nur telefonisch möglich',
    minPhone: 'Das Telefonfeld muss aus mindestens 10 Zeichen bestehen.',
    requireFirstName: 'Es nennt obbligatorio',
    validFirstName: 'Es ist kein gültiger Vorname.',
    requireLastName: 'Ich bin am reichsten da, campo del cognome.',
    validLastName: 'Das Feld Nachname ist erforderlich.',
    requireCity: 'Stadt ist ein Pflichtfeld.',
    validCity: 'Das Stadtfeld ist ungültig',
    requireAddress: 'Es ist ein Adressfeld ist obligatorisch.',
    validAddress: 'Das Adressfeld ist ungültig.',
    requireZip: 'Das Pflichtfeld Postleitzahl.',
    validZip: 'Es ist eine Campo-Postleitzahl, die nicht gültig ist',
    requireCard: 'Es gibt eine Knorpelnummer',
    minCard: 'Nicht genug Symbole.',
    validCard: 'Es gibt keine gültige Kartennummer',
    requireMonth: 'Das Lager der Verfallsmassen und Pflicht.',
    requireYear: 'Ablaufdatum und Pflichtfeld für das Jahr.',
    requireName: 'Das Namensfeld ist erforderlich.',
    validName: 'Das Feld des Namens ist ungültig',
    requireCvv: 'Es ist ein Lebenslauf, der verpflichtend ist.',
    validCvv: 'Das Feld cvv no ist gültig.',
    minFirstName: 'Das Vorname-Feld muss aus mindestens 3 Zeichen bestehen.',
    minLastName: 'Das Nachname-Feld muss aus mindestens 3 Zeichen bestehen.',
    minCity: 'Das Stadtfeld muss aus mindestens 3 Zeichen bestehen.',
    minAddress: 'Das Adressfeld muss aus mindestens 3 Zeichen bestehen.',
    minZip:
      'Das Feld für die Postleitzahl muss aus mindestens 3 Zeichen bestehen.',
    minName: 'Das Namensfeld muss aus mindestens 3 Zeichen bestehen.',
    minCvv: 'Das CVV-Feld muss aus mindestens 3 Zeichen bestehen.',
    specialFirstName:
      'Der Vorname des Feldes darf keine Sonderzeichen enthalten',
    specialLastName: 'Das Feld Nachname darf keine Sonderzeichen enthalten',
    specialName: 'Der Feldname darf keine Sonderzeichen enthalten',
    specialCity: 'Das Feld city darf keine Sonderzeichen enthalten',
  },
  mask: {
    phone: '+43 999 999 999',
    zip: '9999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'IN KONTAKT KOMMEN',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-mail',
    msg: 'Botschaft',
    send: 'Senden',
    alreadyRegistered: 'Sie haben sich bereits registriert',
    unsubscribeLink: 'Link abbestellen',
    worktime: 'Callcenter Arbeitet von 10 bis 17 Uhr',
    phone: 'Telefon: Sofia +359 2 437 4207',
  },
};
